export enum BEFORE_CONTEXT_CHANGE_ACTION {
    STOP = 'stop',
    CONTINUE = 'continue'
}